export default __webpack_public_path__ + "static/media/o-heart-cancel.d5883920.svg";